export const baseTheme = {
  fontSize: {
    tiny: 10,
    extraSmall: 12,
    small: 14,
    medium: 16,
    mediumPlus: 18,
    large: 20,
    extraLarge: 24,
    jumbo: 28,
    huge: 32,
  },
  font: 'Roboto',
  spacing: {
    xxs: 2,
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 24,
    xxxl: 32,
  },
  fontWeight: {
    bold: 'bold',
  },
  border: {
    tiny: 2,
    extraSmall: 4,
    small: 8,
    medium: 12,
    large: 16,
    extraLarge: 20,
    jumbo: 24,
  },
  iconSize: {
    extraSmall: 14,
    small: 18,
    medium: 20,
    large: 24,
    jumbo: 30,
  },
}
